import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ISchedule } from '../models/schedule';
import { ErrorService } from '../helpers/errorService';

@Injectable({
    providedIn: 'root'
})
export class ScheduleService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getSchedules(buildingId: string, schoolYear: string): Observable<{ has_error: boolean, message: string, data: ISchedule[] }> {
        const url = environment.apiBaseUrl + endpoints.schedules.replace(':buildingId', buildingId);

        const params = new HttpParams().set('school_year', schoolYear);

        return this.http.get<{ has_error: boolean, message: string, data: ISchedule[] }>(url, { params }).pipe(
            catchError(this.errorService.handleError)
        );
    }


    createNewSchedule(buildingId: string, scheduleData: FormData): Observable<{ has_error: boolean, message: string, data: any }> {
        const url = environment.apiBaseUrl + endpoints.createNewSchedule.replace(':buildingId', buildingId);
        return this.http.post<{ has_error: boolean, message: string, data: any }>(url, scheduleData).pipe(
            catchError(this.errorService.handleError)
        );
    }

    editSchedule(scheduleId: string, schedule: FormData): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.editSchedule.replace(':scheduleId', scheduleId);
        return this.http.put<any>(url, schedule).pipe(
            catchError(this.errorService.handleError)
        );
    }

    deleteSchedule(scheduleId: string): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.deleteSchedule.replace(':scheduleId', scheduleId);
        return this.http.delete<any>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }
}